/**
 * Generic ajax form handling
 */

export default class Contact{
    constructor() {
        this.form = $('form.form-builder-form');
        this.setEventListeners();
    }

    setEventListeners() {
        this.form.on('submit', e => this.submitForm(e))
    }

    submitForm(e) {
        e.preventDefault();
        $('#error').html('');
        // $('#submit-form').attr('disabled', 'disabled');
        let data = new FormData(this.form[0]);

        $.ajax({
            url: '/about-us/contact-us',
            method: 'POST',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function( data ) {
                $(e.target).replaceWith('<div class="success"><h2>' + data.title + '</h2><p>' + data.message + '</p></div>');
                $('#submit-form').removeAttr("disabled");
            },
            error: function( data ) {
                window.grecaptcha.reset();
                console.log($('form#error'));
                $('#error').remove();
                $(e.target).prepend('<div id="error">'+ data.responseJSON.error  + '</div>');
                $('html, body').animate({
                    scrollTop: $("#error").offset().top - 70
                }, 2000);
                $('#submit-form').removeAttr("disabled");
            },
            complete: function( data ) {
                $('#submit-form').removeAttr("disabled");
            }
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Contact.js